import { AspectRatioBox, Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const BannerSlider = styled(AspectRatioBox)`
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);

  .swiper-backface-hidden .swiper-slide {
    line-height: 0;
  }
`;

const BannerSliderImage = styled(Image)`
  border-radius: var(--radius-m);
  ${({ $isClickable }) => $isClickable && 'cursor: pointer;'}
`;

export { BannerSlider, BannerSliderImage };
